import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { TOGO_DELIVERY_ERROR_POP_UP_TYPE, useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import DeliveryUnavailableModal from "./components/DeliveryUnavailableModal";
import DeliveryOrderFailedModal from "./components/DeliveryOrderFailedModal";
export var DeliveryErrorModals = observer(function (props) {
  // store
  var store = useStore();

  var hidePopUp = function hidePopUp() {
    store.common.showDeliveryErrorPopUp(TOGO_DELIVERY_ERROR_POP_UP_TYPE.NONE);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DeliveryUnavailableModal, {
      isOpen: store.common.deliveryErrorPopUp === TOGO_DELIVERY_ERROR_POP_UP_TYPE.ERROR_DELIVERY_UNAVAILABLE,
      onClose: hidePopUp
    }), /*#__PURE__*/_jsx(DeliveryOrderFailedModal, {
      isOpen: store.common.deliveryErrorPopUp === TOGO_DELIVERY_ERROR_POP_UP_TYPE.ERROR_ORDER_FAILED,
      onClose: hidePopUp,
      resetAndClose: null
    })]
  });
});